import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedLabelComponent } from "./med-label.component";

@NgModule({
  declarations: [
    MedLabelComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedLabelComponent,
  ],
})
export class MedLabelModule { }
